module.exports = __webpack_public_path__ + "static/media/trainStation.3a9a7803.png";